<template>
  <div
    class="wt2-produced-popup"
    @mousemove="onProducedMove"
    @mouseleave="onProducedLeave"
  >
    <wt-masthead-like-header
      v-show="getMastHeadVisibleStatus"
      @toggle="toggleActionPanel"
      @close="closeModal"
      :info-active="getActionPanelOpenStatus"
      :title="video.title"
      :storyboard="true"
      :type="getMastHeadCurrentType"
    />

    <produced-content
      :timeout-control-time="timeoutControlTime"
      :video="video"
      :storyboard="true"
      :modal="true"
    />

    <div v-if="loading" class="wt-dashboard-loader">
      <div class="wt-loader" />
    </div>
  </div>
</template>

<script>
import ProducedContent from 'v/Produced/ProducedContent.vue';
import PopupActionMixin from 'mixins/PopupAction.vue';

export default {
  name: 'StoryboardPopup',
  mixins: [PopupActionMixin],

  components: {
    ProducedContent,
  },

  props: {
    video: { type: Object, required: false, default: null },
    closeModal: { type: Function },
  },

  data() {
    return {
      loading: false,
    };
  },
};
</script>
